module.exports = __webpack_public_path__ + "static/media/ic_sec_healthcare.01741b9d.svg";